import { motion } from "framer-motion";
import { useState, useEffect } from "react";



function HeroChart() {
  // const bars = [45, 70, 95, 125, 155, 185, 215];
  const desktopBars = [45, 70, 95, 125, 155, 185, 215];
  const mobileBars = [24, 38, 52, 70, 90, 110, 128];
const [bars, setBars] = useState(desktopBars);
useEffect(() => {
  const updateBars = () => {
    setBars(window.innerWidth < 640 ? mobileBars : desktopBars);
  };

  updateBars();

  window.addEventListener("resize", updateBars);
  return () => window.removeEventListener("resize", updateBars);
}, []);

  return (
    <motion.div
      animate={{ y: [0, -8, 0] }}
      transition={{
        repeat: Infinity,
        duration: 6,
        ease: "easeInOut",
      }}
    className="relative w-full  sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-auto rounded-[24px] sm:rounded-[28px] lg:rounded-[30px] border border-white/10 bg-gradient-to-br from-[#24153f] via-[#2a1846] to-[#132b44] px-3 sm:px-6 lg:px-7 py-4 sm:py-6 shadow-[0_25px_80px_rgba(0,0,0,.45)] backdrop-blur-2xl overflow-hidden"
    >
      {/* Chart */}
      <div className="relative mt-3 sm:mt-6 h-36 xs:h-40 sm:h-52 md:h-56 lg:h-60">
        {/* Grid */}
        <div className="absolute inset-0 flex flex-col justify-between">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="border-t border-white/5" />
          ))}
        </div>

        {/* Bars */}
        <div className="absolute inset-x-0 bottom-4 top-0 flex items-end justify-center gap-3 sm:gap-2 md:gap-3 lg:gap-4">
          {bars.map((height, index) => (
            <motion.div
              key={index}
              initial={{ scaleY: 0 }}
              animate={{
                scaleY: [0, 1, 0.97, 1],
              }}
              transition={{
                duration: 4,
                delay: index * 0.15,
                repeat: Infinity,
                repeatDelay: 2,
                ease: "easeInOut",
              }}
              style={{
                height: `${height}px`,
                transformOrigin: "bottom",
              }}
              className="
                relative
              w-3
              sm:w-4
              md:w-5
              lg:w-7
              xl:w-8
                rounded-t-full
                overflow-visible
              "
            >
              {/* Bar */}
              <div className="absolute inset-0 rounded-t-full bg-gradient-to-t from-violet-700 via-fuchsia-500 to-cyan-300" />

              {/* Glow */}
              <motion.div
                animate={{
                  opacity: [0.25, 0.55, 0.25],
                }}
                transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  delay: index * 0.15,
                }}
                className="absolute inset-0 rounded-t-full bg-fuchsia-500 blur-md"
              />
            </motion.div>
          ))}
        </div>

        {/* Bottom Baseline */}
        <div className="absolute bottom-4 left-0 right-0 border-t border-white/10" />
      </div>
    </motion.div>
  );
}

export default HeroChart;